var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0V8h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M3.915 4.003a2.423 2.423 0 011.912-2.378 2.43 2.43 0 100 4.755 2.437 2.437 0 01-1.912-2.377zm3.127-2.265l.173.532h.562l-.457.33.172.533-.45-.33-.45.33.173-.533-.45-.33h.555l.172-.532z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.685 2.78l.173.532h.562l-.45.33.173.533-.458-.33-.45.33.173-.533-.45-.33h.555l.172-.532zm2.715 0l.173.532h.555l-.45.33.172.533-.45-.33-.45.33.173-.533-.458-.33h.563L8.4 2.78zm-.525 1.567l.173.533h.562l-.45.33.173.532-.458-.33-.45.33.173-.532-.45-.33h.555l.172-.533zm-1.665 0l.173.533h.562l-.457.33.172.532-.45-.33-.45.33.173-.532-.458-.33h.563l.172-.533z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/Singapore.9bb80b7169143738f1f13e2608df4100.svg";
export { ForwardRef as ReactComponent };